import {CommonModule} from "@angular/common";
import {Component, inject, Input} from "@angular/core";
import {ControlContainer, ReactiveFormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldAppearance} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {TranslateModule} from "@ngx-translate/core";
import {StartEnd} from "../../models";
import {CustomFormControl, CustomFormControlProps, CustomFormGroup} from "../../utils";
import {MatListModule} from "@angular/material/list";
import {TilbyCurrencyPipe} from "@tilby/tilby-ui-lib/pipes/tilby-currency";
import {TilbyGesturesDirective} from "@tilby/tilby-ui-lib/directives/tilby-gestures";

@Component({
    selector: 'tilby-list-of-items',
    templateUrl: './tilby-list-of-items.component.html',
    styleUrls: ['./tilby-list-of-items.component.scss'],
    standalone: true,
    imports: [CommonModule, MatInputModule, MatIconModule, MatListModule, MatButtonModule, ReactiveFormsModule, TranslateModule, TilbyCurrencyPipe, TilbyGesturesDirective],
})
export class TilbyListOfItemsComponent {
    private parentControl = inject(ControlContainer);

    @Input({required:true}) formControlLabel!: string | number;
    @Input() appearance: MatFormFieldAppearance = 'fill';
    @Input() hintAlign: StartEnd ='end';
    @Input() flex: number = 1;

    protected parentForm!:CustomFormGroup<any>;
    protected control!:CustomFormControl;
    protected customProps: CustomFormControlProps<any,any> = new CustomFormControlProps();

    ngOnInit(){
        this.parentForm=this.parentControl.control as CustomFormGroup<any>;
        this.control=this.parentForm?.controls[this.formControlLabel] as CustomFormControl;
        this.customProps=this.control.customProps;
    }
}
